import { Environment } from './model';

export const environment: Environment = {
  production: false,
  SERVER_PORT: 4000,
  API_VERSION: 3,
  bestchefsId: 56,
  ticketsEnabled: false,
} as const;
